module.exports = __webpack_public_path__ + "media/components/signup/static/app-mockup-5fcfb7fd00da00bdb5c1e6a41d048642.png";